import { gql } from "apollo-boost"

export const CreateReplacementDraft = gql`
  mutation CreateReplacementDraft($conceptId: ID!) {
    createReplacementDraft(conceptId: $conceptId)
  }
`